var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell-box",class:{'focus-cell-box': _vm.focusCellBox}},[_c('div',{staticClass:"edit-cell",attrs:{"contenteditable":"true"},on:{"focus":_vm.focus,"blur":_vm.blur,"input":_vm.inputHandler,"click":_vm.clickHandler}})])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/TableCellBox/TableCellBox.vue